import { createStore } from 'satcheljs';
import { WhatsNewCardStoreObject } from './schema/WhatsNewCardStoreObject';

export interface WhatsNewCardStore {
    cards: WhatsNewCardStoreObject[];
}

const initialWhatsNewStoreState: WhatsNewCardStore = {
    cards: null,
};

export let whatsNewStore = createStore<WhatsNewCardStore>(
    'whatsNewStore',
    initialWhatsNewStoreState
);
